import { render, staticRenderFns } from "./user-spin.vue?vue&type=template&id=6780dab2&scoped=true&"
import script from "./user-spin.vue?vue&type=script&lang=js&"
export * from "./user-spin.vue?vue&type=script&lang=js&"
import style0 from "./user-spin.vue?vue&type=style&index=0&id=6780dab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6780dab2",
  null
  
)

export default component.exports